export default {
  SET_DATA (state, data) {
    state.banner = data
  }
}